__webpack_require__.p = "https://magnify.uat.magmutual.com/";